module.exports = __webpack_public_path__ + "img/ics_o_commodity.921ff355.svg";